import { Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment.dev';
import { Environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService implements OnInit {
  currentLogLevel: LogLevel;
  constructor( private _route: ActivatedRoute,
    private _router: Router)
  {

  }

  ngOnInit() {
    this._route.queryParams.pipe().subscribe(params => {
      // Find Parameters
      this.currentLogLevel = LogLevel.Error;
      if (environment.status == Environment.Dev
        || environment.status == Environment.Stage) {
        this.currentLogLevel = LogLevel.Trace;
      }

      if (params['loglevel']) {
        this.currentLogLevel = (LogLevel[`${params['loglevel']}`]);
      }
    });
  }

  public error(message: string, error?: any) {
    if (this.currentLogLevel >= LogLevel.Debug) {
      let fullMessage = message;

      if (error) {
        // Handle different error types
        if (error instanceof Error) {
          fullMessage += ` - Error: ${error.message}`;
          if (error.stack) {
            fullMessage += ` - Stack: ${error.stack}`;
          }
        } else if (typeof error === 'object') {
          fullMessage += ` - Error: ${JSON.stringify(error)}`;
        } else {
          fullMessage += ` - Error: ${error}`;
        }
      }

      this.LogError(fullMessage, 'Error');
    }
  }

  public debug(message: string) {
    if (this.currentLogLevel >= LogLevel.Debug)
      this.LogError(message, 'Debug');
  }

  public info(message: string) {
    if (this.currentLogLevel >= LogLevel.Info)
      this.LogError(message, 'Info');
  }

  public trace(message: string) {
    if (this.currentLogLevel >= LogLevel.Trace)
      this.LogError(message, 'Trace');
  }

  public warn(message: string) {
    if (this.currentLogLevel >= LogLevel.Warn)
      this.LogError(message, 'Warn');
  }

  private LogError(message: string, errorType: string) {
    // Usual NLOG message
    //${longdate} | ${uppercase:${level}} | ${callsite}:${callsite-linenumber} - ${exception:format=toString} | ${message}

    // Get stacktrace and find function hopefully is 13
    // TODO: it wasn't 13 on all functions. Find a Surefire (hah) way to get the original called function.
    /*var obj: any = {};
    Error.stackTraceLimit = 50;
    Error.captureStackTrace(obj);
    let stacktrace = (<string>obj.stack).split('\n')[13].trim().replace("at ", "").split(" ")[0];*/
    // | ${stacktrace}

    // Log the message
    console.log(`${new Date().toLocaleString()} | ${errorType} | ${message}`);
  }


}

enum LogLevel {
    'Error',
    'Debug',
    'Info',
    'Trace',
    'Warn' ,
}
